import React from "react";

import logo from "../../assets/images//logo.png";

import "./style.css";
const RoundedImage = ({ className, userPicture }) => {
  return (
    <div className={`profile__image-wrap ${className}`}>
      <img src={logo} alt="profile" />
    </div>
  );
};

export default RoundedImage;
